import axios from "axios";

import type { ClientParkingAvailabilityResponse, GETPLCGWApiResponse, KeyFobDetailsAPIResponse } from "../shared/interface/dashboard.interface";
import { LocationStatusListResponse } from "../shared/interface/locationStatusList.interface";

export const getDashboardDataByCustomerAndLocationId = async (customerId: number, locationId: number) => {
  let query = `${process.env.REACT_APP_API_URL}/dashboard/${customerId}/${locationId}`;

  try {
    const response = await axios.get(query);

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getPLCGWStatusByCustomerAndLocationId = async (customerId: number, locationId: number) => {
  let query = `${process.env.REACT_APP_API_URL}/dashboard/plc-gw-status/${customerId}/${locationId}`;

  try {
    const response = await axios.get(query);

    return response.data as GETPLCGWApiResponse;
  } catch (error) {
    throw error;
  }
};

export const getKeyFobDetailsById = async (keyFobId: number) => {
  let query = `${process.env.REACT_APP_API_URL}/key-fob/details-by-keyfobId/${keyFobId}`;

  try {
    const response = await axios.get(query);

    return response.data as KeyFobDetailsAPIResponse;
  } catch (error) {
    throw error;
  }
};

export const getKeyFobDetailsBySearchQuery = async (searchQuery: string, customerId: number, locationId: number) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/key-fob/details-by-search-query/${customerId}/${locationId}/${searchQuery}`);
    return response.data as KeyFobDetailsAPIResponse;
  } catch (error) {
    throw error;
  }
};

export const getClientParkingAvailabilityStats = async (customerId: number, locationId: number, page: number, pageSize: number) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/dashboard/parking-availability-stats/${customerId}/${locationId}?page=${page}&pageSize=${pageSize}`);
    return response.data as ClientParkingAvailabilityResponse;
  } catch (error) {
    throw error;
  }
};

export const getLocationPLCGatewayStatusList = async (params: { page: number; pageSize: number; searchQuery: string }) => {
  try {
    let query = `${process.env.REACT_APP_API_URL}/dashboard/plc-gw-status-list?page=${params.page}&pageSize=${params.pageSize}`;

    if (params.searchQuery) {
      query += `&searchQuery=${params.searchQuery}`;
    }

    const response = await axios.get(query);
    return response.data as LocationStatusListResponse;
  } catch (error) {
    throw error;
  }
};
